<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="halftitlepage">
<p class="sp1"> </p>
<p class="TPHT">Send Lazarus</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle2.vue?6f8b6662